import { WS } from '@deriv/shared';
import { observable, action, runInAction, makeObservable } from 'mobx';
import { everymanPipelineFail, everymanPipelineWarn } from 'Utils/everyman-pipeline-log';
import BaseStore from './base-store';

export default class ActiveSymbolsStore extends BaseStore {
    active_symbols = [];

    constructor() {
        // TODO: [mobx-undecorate] verify the constructor arguments and the arguments of this automatically generated super call
        super();

        makeObservable(this, {
            active_symbols: observable,
            setActiveSymbols: action.bound,
        });
    }

    async setActiveSymbols() {
        try {
            const { active_symbols, error } = await WS.authorized.activeSymbols();
            runInAction(() => {
                if (!active_symbols.length || error) {
                    this.active_symbols = [];
                    if (error) {
                        everymanPipelineFail(
                            'active_symbols_ws',
                            'WS.active_symbols returned error — chart symbol list may be empty',
                            null,
                            {
                                api_error: error,
                                msg_type: 'active_symbols',
                            }
                        );
                    } else if (!active_symbols?.length) {
                        everymanPipelineWarn(
                            'active_symbols_ws',
                            'WS.active_symbols returned empty list — chart may not load a symbol',
                            {}
                        );
                    }
                    return;
                }
                this.active_symbols = active_symbols;
            });
        } catch (e) {
            everymanPipelineFail(
                'active_symbols_ws',
                'WS.activeSymbols() threw — unauthorized socket or network',
                e,
                {}
            );
            runInAction(() => {
                this.active_symbols = [];
            });
        }
    }
}
